import { render, staticRenderFns } from "./PolicyDocument.vue?vue&type=template&id=490c9990"
import script from "./PolicyDocument.vue?vue&type=script&lang=js"
export * from "./PolicyDocument.vue?vue&type=script&lang=js"
import style0 from "./PolicyDocument.vue?vue&type=style&index=0&id=490c9990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports